import { Html } from "@react-three/drei";
import { useMemo } from "react";
import { MeshPhysicalMaterial, Vector3 } from "three";

export function AppleAidPin({ position, label, name }) {
  const material = useMemo(
    () =>
      new MeshPhysicalMaterial({
        color: "#ffffff",
        transparent: true,
        opacity: 0.88,
        roughness: 0.15,
        metalness: 0.0,
        clearcoat: 1.0,
        clearcoatRoughness: 0.1,
      }),
    []
  );

  // ★ ラベルのワールド座標（ピンの真上）
  const labelPos = new Vector3(position[0], position[1] + 2.5, position[2]);

  return (
    <>
      {/* ピン本体（scale はここだけ） */}
      <group position={position} scale={[0.5, 0.5, 0.5]}>
        <mesh material={material} castShadow>
          <sphereGeometry args={[1.2, 32, 32]} />
        </mesh>

        <mesh position={[0, -2, 0]} material={material} castShadow>
          <cylinderGeometry args={[0.25, 0.25, 3, 16]} />
        </mesh>
      </group>

      {/* ★ ラベルは group の外に出してワールド座標で固定 */}
      <Html
        position={labelPos}
        center
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pointerEvents: "none",
        }}
      >
        {/* 青丸（区分） */}
        <div
          style={{
            background: "#007aff",
            color: "white",
            width: "28px",
            height: "28px",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "14px",
            fontWeight: "600",
            boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
          }}
        >
          {label}
        </div>

        {/* 区分名称ラベル */}
        <div
          style={{
            marginTop: "4px",
            background: "white",
            padding: "4px 8px",
            borderRadius: "8px",
            fontSize: "12px",
            color: "#333",
            boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
            whiteSpace: "nowrap",
          }}
        >
          {name}
        </div>
      </Html>
    </>
  );
}
